/* global Swiper */
const carsSliderElement = document.querySelectorAll('[data-slider="cars-slider"]');
const technicalDataPanelElement = document.querySelectorAll('.cars-info');

// *******************************************************************************
// 1.0 - Change technical data on change of cars slider slide
// *******************************************************************************

function changeTechnicalData(dataId) {
  Array.prototype.forEach.call(technicalDataPanelElement, (elem) => {
    if (elem.classList.contains('is-active')) {
      elem.classList.remove('is-active');
    }
    if (elem.getAttribute('id') === dataId) {
      elem.classList.add('is-active');
    }
  });
}


// *******************************************************************************
// 2.0 - Car slider
// *******************************************************************************

Array.prototype.forEach.call(carsSliderElement, (el) => {
  const imageSliderParent = el.closest('.sc-cars-slider');
  const arrowRight = imageSliderParent.querySelectorAll('.arrow--right');
  const arrowLeft = imageSliderParent.querySelectorAll('.arrow--left');

  const carsSliderElementOptions = {
    slidesPerView: 3,
    centeredSlides: true,
    speed: 500,
    spaceBetween: 0,
    loop: false,
    watchOverflow: true,
    navigation: {
      nextEl: arrowRight,
      prevEl: arrowLeft,
    },
  };
  // eslint-disable-next-line no-unused-vars
  const carSlider = new Swiper(el, carsSliderElementOptions);

  carSlider.on('transitionEnd', () => {
    const currentSlideContentElement = imageSliderParent.querySelectorAll('.swiper-slide-active .cars-slider__content')[0];
    const techDataId = currentSlideContentElement.getAttribute('data-info');
    changeTechnicalData(techDataId);
  });
});
